module.exports = __webpack_public_path__ + "img/real.47876227.svg";